const productList = [
    // {
    //     imgPo: "imgLeft",
    //     showToHome: true,
    //     index: 3,
    //     scale: "1-2",
    //     toHomeImg: "/static/img/product/6.png",
    //     type: "S320-T1",
    //     name: "Iris Recognition Terminal with Temperature Measure",
    //     title: "Iris Recognition Terminal with Temperature Measure",
    //     img: "/static/img/product/10.png",
    //     point: [
    //         "Contactless, Safety and Healthy",
    //         "Accuracy and Efficiency",
    //         "Plug and Play, Rapid Deployment",
    //     ],
    //     desc:
    //         "S320-T1  iris recognition and temperature detection integrated machine integrates the infrared heat technology, iris recognition and face recognition to accurately and efficiently complete the body temperature detection and identity recognition for the high protected personnel wearing masks and goggles. S320-T1 can not only complete the early warning of the personnel with abnormal temperature, but also immediately confirm the identity of the recent close contacts with abnormal temperature, so as to realize access control of the floating personnel efficiently and safely. S320-T1 is especially suitable for airport, station, other hub of communication, hospital, school, government building,factory, enterprise, community, etc",
    //     fc: [
    //         { img: "", name: "园区管理" },
    //         { img: "", name: "考勤打卡" },
    //     ],
    //     btn: {
    //         show: true,
    //         text: "Detail",
    //     },
    //     param: [
    //         { key: "Product Model", val: "S320-T1" },
    //         { key: "Product Size", val: "160mm*260mm*45mm" },
    //         {
    //             key: "Display Screen",
    //             val: "Standard configuration is 7-inch touch screen",
    //         },
    //         {
    //             key: "Identify Distance Range",
    //             val: "Identification: 45 ~ 65cm / Temperature detection：＜5cm",
    //         },
    //         {
    //             key: "Identify Height Range",
    //             val: "Support height adjustment by users themselves , covering 40cm",
    //         },
    //         {
    //             key: "Registration Time",
    //             val: "Iris and Face registration time ＜3s",
    //         },
    //         {
    //             key: "Recognition Time",
    //             val: "Identification and Temperature detection＜2s",
    //         },
    //         {
    //             key: "Recognition Accuracy",
    //             val: "FAR:<0.00001%,FRR:<0.1%;Temperature detection:±0.3℃",
    //         },
    //         {
    //             key: "Terminal Registration Database",
    //             val:
    //                 "Standard configuration is 10,000 users’ data (It can be customized according to user requirements)",
    //         },
    //         {
    //             key: "NIR Light Source",
    //             val: "LED light source complies with IEC-62471",
    //         },
    //         {
    //             key: "Iris Image",
    //             val: "Iris image complies with IS029794-6 and ISO19794-6",
    //         },
    //         {
    //             key: "Face Image",
    //             val: "Face image complies with IS029794-5 and ISO19794-5",
    //         },
    //         { key: "Voice Prompt (Light)", val: "Support" },
    //     ],
    // },
    {
        imgPo: "imgLeft",
        showToHome: true,
        index: 2,
        scale: "1-1",
        toHomeImg: "/static/img/product/2.png",
        type: "W200",
        name: "Hand-Held Iris-Face Acquisition Terminal",
        title: "Hand-Held Iris-Face Acquisition Terminal",
        img: "/static/img/product/9.png",
        point: ["Light, Hand-Held", "All-Weather", "High-Resolution Imaging"],
        desc:
            "The appearance of the W200 is small and portable, and the use of the device is not affected by the external environment light. W200 integrates iris and face image information registration, and the registration speed is fast. W200 can connect all iris and face fusion recognition products which are developed by IriStar, and integrate the information management system to manage personnel access records, visitors records and important area permissions in a unified way.",
        fc: [
            { img: "", name: "人员注册" },
            { img: "", name: "虹膜人脸采集" },
        ],
        btn: {
            show: true,
            text: "Detail",
        },
        param: [
            { key: "Product Model", val: "W200" },
            { key: "Product Size", val: "193mm*169mm*74mm" },
            { key: "Product Form", val: "Hand-Held/Bracket-fixed" },
            { key: "Input Interface", val: "USB2.0/3.0" },
            { key: "Power Supply", val: "USB" },
            { key: "Line Length of USB", val: "1m" },
            { key: "Power", val: "5W" },
            { key: "Identify Distance Range", val: "10cm" },
            { key: "Frame Rate", val: "30fps" },
            { key: "Iris Image Resolution", val: "640*480" },
            { key: "Auxiliary Alignment Mode", val: "Mirror feedback" },
            { key: "Operation Temperature", val: "0~45℃" },
            { key: "Operation Humidity", val: "0-90% RH，No condensation" },
            {
                key: "NIR Light Source",
                val: "LED light source complies with IEC-62471:2006",
            },
            { key: "Operating System", val: "Windows、Linux" },
            { key: "Registration Time", val: "<2s" },
            { key: "Recognition Time", val: "<1s" },
        ],
    },
    {
        imgPo: "imgLeft",
        showToHome: true,
        index: 4,
        scale: "1-1",
        toHomeImg: "/static/img/product/4.png",
        type: "S300-UC",
        name: "Desktop Iris-Face Recognition Terminal",
        title: "Desktop Iris-Face Recognition Terminal",
        img: "/static/img/product/7.png",
        point: ["Portable Socket", "No Drive Operation", "High Security Encryption"],
        desc:
            "S300-UC medium distance registration and recognition module is self-developed by IriStar to quickly acquire users' iris and color face images in real time, which is suitable for iris recognition and face recognition with recognition distance of 45-65cm. S300-UC is applied to medium distance accurate identity recognition scenarios, such as security scenarios with high confidentiality requirements or business scenarios unmanned payment.",
        fc: [
            { img: "", name: "金融银行" },
            { img: "", name: "超商便利" },
            { img: "", name: "政务工作" },
        ],
        btn: {
            show: true,
            text: "Detail",
        },
        param: [
            { key: "Product Model", val: "S300-UC" },
            { key: "Product Size", val: "165mm*60mm*47mm" },
            { key: "Identify Distance Range", val: "45~65cm" },
            { key: "Registration Time", val: "<2s" },
            { key: "Recognition Time", val: "<1s" },
            {
                key: "NIR Light Source",
                val: "LED light source complies with IEC-62471:2006",
            },
            { key: "Ambient Light", val: "Using led white light fill lamp" },
            {
                key: "Input Interface",
                val: "USB2.0/3.0;5.1*2.1mmPower interface",
            },
            { key: "Operation Temperature", val: "-10°~55°" },
            { key: "Operation Humidity", val: "0-90% RH，No condensation" },
            { key: "Development Platform", val: "Android、Windows、Linux" },
            { key: "Application Environment", val: "Indoor" },
            {
                key: "Iris Image",
                val: "Iris image complies with IS029794-6 and ISO19794-6",
            },
            {
                key: "Face Image",
                val: "Face image complies with IS029794-5 and ISO19794-5",
            },
        ],
    },
    {
        imgPo: "imgLeft",
        showToHome: true,
        index: 5,
        toHomeImg: "/static/img/product/5.png",
        type: "S200P",
        name: "Long-Distance Iris-Face Recognition Terminal",
        title: "Long-Distance Iris-Face Recognition Terminal",
        img: "/static/img/product/1.png",
        point: ["Elegant Look", "Perfect Curve", "Excellent Industrial Design"],
        desc:
            "S200P hybrid biometric recognition integrated machine has a beautiful and generous appearance, which matches with many high-end scenes. S200P can realize the identity registration and recognition, real-time data processing and information management by combining with IriStar information management system. Finally, S200P realized unified management of staff attendance, staff access records, black and white list management, visitors management and important regional authorities",
        fc: [
            { img: "", name: "智能楼宇" },
            { img: "", name: "VIP客户" },
        ],
        btn: {
            show: true,
            text: "Detail",
        },
        param: [
            { key: "Product Model", val: "S200P" },
            {
                key: "Product Size",
                val: "Height：1850mm, base diameter：400mm",
            },
            { key: "Product Form", val: "Column" },
            { key: "Operation Temperature", val: "0~45℃" },
            { key: "Operation Humidity", val: "0-90% RH，No condensation" },
            {
                key: "Data and Information Management",
                val: "IriStar Cetus Device management platform",
            },
            {
                key: "Recognition Mode",
                val: "Long-Distance iris recognition、Face Recognition、Bioassay test",
            },
            {
                key: "Bioassay Test",
                val:
                    "Silent bioassay test / printing / display / contact lenses / facial model and other prosthesis detection",
            },
            { key: "Registration Time", val: "<3s" },
            { key: "Recognition Time", val: "<1s" },
            {
                key: "Application Environment",
                val: "Indoor/ Night / backlight",
            },
            {
                key: "Operating System",
                val: "Win7 64 bit or higher edition/Linux/Android",
            },
            { key: "Registration Mode", val: "1:N / 1:1" },
            { key: "Identify Distance Range", val: "1m~1.2m" },
            {
                key: "Identify Height Range",
                val:
                    "1.55~1.85m (customizable, max:1.3-1.95m, supporting electric height range adjustment)",
            },
            { key: "Recognition Accuracy", val: "FAR:<0.00001%,FRR:<0.1%;" },
            // {key: '识别拒识率', val: '0.1%'},
            {
                key: "Iris Image",
                val: "Iris image complies with IS029794-6 and ISO19794-6",
            },
            {
                key: "Face Image",
                val: "Face image complies with IS029794-5 and ISO19794-5",
            },
            {
                key: "NIR Light Source",
                val: "LED light source complies with IEC-62471:2006",
            },
            { key: "Work Mode", val: "Online/Networking" },
        ],
    },
    {
        imgPo: "imgLeft",
        type: "S260P",
        name: "Driver Iris-Face Recognition Terminal",
        title: "Driver Iris-Face Recognition Terminal",
        img: "/static/img/product/5.png",
        point: [
            "Combination of Human Recognition and Vehicle Identification",
            "Recognition on Car",
            "Access at a Glance",
        ],
        desc:
            "S260P is an integrated biometric recognition machine specially designed for intelligent travel, which can be combined with license plate recognition equipment to effectively complete the integrated recognition of people and vehicles. And therefore S260P achieves the best experience, performance and cost. S260P adopts outdoor environment design, adapts to various outdoor lighting conditions, and has good waterproof and dustproof effect. The appearance design style of the product is consistent with the license plate recognition product, which is conducive to integration. The erection height of S260P can also be adjusted to adapt to the driver recognition which drivies various models.",
        fc: [
            { img: "", name: "机关单位" },
            { img: "", name: "无人停车场" },
        ],
        btn: {
            show: true,
            text: "Detail",
        },
        param: [
            { key: "Product Model", val: "S260P" },
            {
                key: "Product Size",
                val: "400mm*300mm*1782mm(head height 755mm)",
            },
            { key: "Product Form", val: "Column" },
            { key: "Operation Temperature", val: "-10℃~55℃" },
            { key: "Operation Humidity", val: "0-90% RH，No condensation" },
            {
                key: "Data and Information Management",
                val: "IriStar Cetus Device management platform",
            },
            {
                key: "Recognition Mode",
                val: "Long-Distance iris recognition、Face Recognition、Bioassay test",
            },
            {
                key: "Bioassay Test",
                val:
                    "Silent bioassay test / printing / display / contact lenses / facial model and other prosthesis detection",
            },
            { key: "Registration Time", val: "<3s" },
            { key: "Recognition Time", val: "<1s" },
            {
                key: "Application Environment",
                val: "Indoor/ Unclosed Indoor/Night / backlight",
            },
            {
                key: "Operating System",
                val: "Win7 64 bit or higher edition/Linux/Android",
            },
            { key: "Registration Mode", val: "1:N / 1:1" },
            { key: "Identify Distance Range", val: "1m~1.2m" },
            { key: "Identify Height Range", val: "1.50~1.90m" },
            { key: "Recognition Accuracy", val: "FAR:<0.00001%,FRR:<0.1%;" },
            // {key: '识别拒识率', val: '0.1%'},
            {
                key: "Iris Image",
                val: "Iris image complies with IS029794-6 and ISO19794-6",
            },
            {
                key: "Face Image",
                val: "Face image complies with IS029794-5 and ISO19794-5",
            },
            {
                key: "NIR Light Source",
                val: "LED light source complies with IEC-62471:2006",
            },
            { key: "Work Mode", val: "Online/Networking" },
        ],
    },
    {
        imgPo: "imgLeft",
        showToHome: true,
        index: 1,
        toHomeImg: "/static/img/product/1.png",
        type: "S210G-S320G",
        name: "Hybrid Biometric Intelligent Access Gate",
        title: "Hybrid Biometric Intelligent Access Gate",
        img: "/static/img/product/4.png",
        point: ["IriStar Latest Technology", "Access Gate for Huge-Scale", "Very Simple"],
        desc:
            'S210G/S320G Hybrid biometric intelligent gate realizes three functions,including "iris recognition + bioassay test+identity authentication". And S210G/S320G  has been applied in customs clearance, exit and entry, subway station and other scenes in many regions of China. S210G/S320G not only greatly guarantees the safety of identity authentication, but also improves the efficiency of security inspection and monitoring, and meets the requirements that  hundred million level population is identified rapidly.',
        fc: [
            { img: "", name: "机关单位" },
            { img: "", name: "无人停车场" },
        ],
        btn: {
            show: true,
            text: "Detail",
        },
        param: [
            { key: "Product Model", val: "S210G/S320G" },
            {
                key: "Product Size",
                val: "170mm*130mm*750mm (Equipment on the gate)",
            },
            { key: "Product Form", val: "Column" },
            { key: "voltage supply", val: "AC110-220V±10%，50Hz" },
            {
                key: "Shell Material",
                val: "1.5mm (customized 2.0mm) 304 stainless steel wire drawing plate",
            },
            { key: "Power", val: "40W (peak), 20W (standby)" },
            { key: "Operation Temperature", val: "-10~55℃" },
            { key: "Operation Humidity", val: "0-90% RH，No condensation" },
            { key: "Registration Time", val: "<3s" },
            { key: "Recognition Time", val: "<1s" },
            {
                key: "Data and Information Management system",
                val: "IriStar Cetus Device management platform",
            },
            {
                key: "Recognition Mode",
                val: "Medium or Long-Distance iris recognition、Face Recognition",
            },
            {
                key: "Bioassay Test",
                val:
                    "Silent bioassay test / printing / display / contact lenses / facial model and other prosthesis detection",
            },
            {
                key: "Application Environment",
                val: "Indoor/ Night / backlight",
            },
            {
                key: "Operating System",
                val: "Win7 64 bit or higher edition/Linux/Android",
            },
            { key: "Registration Mode", val: "1:N / 1:1" },
            {
                key: "Identify Distance Range",
                val: "1m~1.2m(S210G)/45~65cm(S320G)",
            },
            {
                key: "Identify Height Range",
                val: "1.55~1.85m (customizable, max:1.3-1.95m)",
            },
            { key: "Recognition Accuracy", val: "FAR:<0.00001%,FRR:<0.1%;" },
            // {key: '识别拒识率', val: '0.1%'},
            {
                key: "Iris Image",
                val: "Iris image complies with IS029794-6 and ISO19794-6",
            },
            {
                key: "Face Image",
                val: "Face image complies with IS029794-5 and ISO19794-5",
            },
            {
                key: "NIR Light Source",
                val: "LED light source complies with IEC-62471:2006",
            },
            { key: "Work Mode", val: "Online/Networking" },
        ],
    },
    {
        imgPo: "imgLeft",
        toHomeImg: "/static/img/product/12.png",
        type: "F200",
        name: "Intelligent terminal for dynamic face recognition",
        title: "Intelligent terminal for dynamic face recognition",
        img: "/static/img/product/12.png",
        point: ["Fast identification", "Rich interfaces", "Three prevention products"],
        desc:
            "The F200 dynamic face recognition intelligent terminal adopts the powerful and reliable Hisilicon chip and Linux operating system, and is equipped with the core algorithm independently developed by deep learning. It is a dynamic face recognition intelligent terminal that supports 100000 face databases, supports live detection, adapts to various harsh light environments, and truly meets the outdoor environment.",
        fc: [
            { img: "", name: "Face recognition" },
            { img: "", name: "Robust and reliable chip" },
        ],
        btn: {
            show: true,
            text: "Detail",
        },
        param: [
            { key: "Product model", val: "F200" },
            { key: "processor", val: "Hi3516CV500,双核Cortex A7@900M,0.5Tops NNIE FPU" },
            { key: "DDR3", val: "512MB (Optional 1GB)" },
            { key: "Flash", val: "2GB (scalable to 4)/8GB）" },
            { key: "Maximum number of users", val: "5000 people (can be expanded to 2W people)" },
            {
                key: "In vivo detection",
                val:
                    "Support for silent live detection;/Support printing/display/Beautiful pupil/Detection of prosthesis such as facial mask",
            },
            { key: "display", val: "8 inch, IPS, resolution: 800 * 1280" },
            { key: "Touch screen (optional)", val: "G capacitor explosion proof touch screen" },
            { key: "camera", val: "HD 2 megapixel, wide dynamic, monocular camera" },
            {
                key: "Infrared temperature measurement module",
                val: "Measurement accuracy: + / - 1.5% of reading temperature resolution: 0.1 ℃",
            },
            { key: "operating system", val: "Linux" },
            { key: "Recognition pattern", val: "1：N Face recognition" },
            { key: "", val: "2：1 Witness verification" },
            { key: "In vivo detection", val: "Monocular living" },
            { key: "Communication protocol", val: "MQTT/Http/Https/Socket and other protocols" },
            {
                key: "SDK",
                val: "Complete development documents, support third-party platform docking",
            },
            {
                key: "Independent development platform",
                val: "Support the platform of Zhongke Hongxing intelligent identification system",
            },
            { key: "Ethernet", val: "10/100/1000 adaptive" },
            { key: "USB", val: "2个" },
            { key: "4G network (optional)", val: "4G all China Netcom" },
            { key: "WiFi (optional)", val: "IEEE802.11a/b/g/n" },
            { key: "RS485", val: "support" },
            { key: "Wigan input, output", val: "Weigand26/34" },
            { key: "Switch output", val: "NC,COM,NO" },
            { key: "IO output", val: "IN,OUT" },
            {
                key: "RFID reader (optional)",
                val:
                    "ISO / IEC 14443 A &amp; B, NFC, Mifare1 card, reading distance 1-5cm, 13.56MHz",
            },
            { key: "ID card reader (optional)", val: "Support USB external connection" },
            { key: "USB AP", val: "Support USB external connection" },
            { key: "ID card reader (optional)", val: "support" },
            { key: "Power Supply", val: "12V,2A" },
            { key: "working temperature ", val: "–20℃-60℃" },
            { key: "Storage temperature", val: "–30℃-70℃" },
            { key: "ambient humidity", val: "5%RH-95%RH (no condensation)" },
            { key: "Waterproof grade", val: "IP65" },
        ],
    },
    {
        imgPo: "imgLeft",
        toHomeImg: "/static/img/product/13.png",
        type: "U",
        name: "Iris encryption authentication U disk",
        title: "Iris encryption authentication U disk",
        img: "/static/img/product/13.png",
        point: [
            "Local encryption, double security",
            "Intelligent opening, instant unlocking",
            "Lightweight handheld, plug and play",
        ],
        desc:
            "Irisign is the world's leading iris encryption authentication U disk. It is small, portable, light and portable, plug and play. Using high security biometric technology, through high-resolution lens accurate capture, without networking, iris entry and verification can be completed to ensure information security.",
        fc: [
            { img: "", name: "Double security" },
            { img: "", name: "Instant unlocking" },
            { img: "", name: "Plug and play" },
        ],
        btn: {
            show: true,
            text: "Detail",
        },
        param: [
            { key: "model", val: "Iristar S1" },
            { key: "Recognition mode", val: "Binocular registration" },
            { key: "size", val: "77*23*11mm" },
            { key: "weight", val: "27g" },
            { key: "power", val: "2.1W" },
            { key: "Working distance", val: "15-25cm" },
            { key: "Input interface", val: "TYPE-C USB3.0" },
            { key: "Auxiliary alignment", val: "Mirror feedback" },
            { key: "accuracy ", val: "FAR<0.0001% FRR<0.1%" },
            { key: "Identification time", val: "0.5S" },
            { key: "work environment", val: "indoor environment (Avoid direct sunlight)" },
            { key: "working temperature ", val: "0-40℃" },
            { key: "storage capacity", val: "32G/128G" },
        ],
    },
    {
        imgPo: "imgLeft",
        toHomeImg: "/static/img/product/13.png",
        type: "S330B",
        name: "Wall mounted iris face recognition machine",
        title: "Wall mounted iris face recognition machine",
        img: "/static/img/product/14.png",
        point: [
            "Fast face recognition",
            "Dual live detection",
            "Flexible customs clearance and quick deployment",
        ],
        desc:
            "High speed facial feature recognition speed (face < 1s, iris < 1.5s); iris and face double live detection to achieve ultra-high security; four customs clearance methods randomly combined, fast switching; support networking applications, 2 hours to complete the installation and deployment.",
        fc: [
            { img: "", name: "Speed recognition" },
            { img: "", name: "In vivo detection" },
            { img: "", name: "Quick deployment" },
        ],
        btn: {
            show: true,
            text: "View details",
        },
        param: [
            { key: "model", val: "S330B" },
            { key: "Product size", val: "148mm*248mm*33.5mm" },
            {
                key: "Product function",
                val: "1. Iris registration, iris recognition, iris clearance, iris attendance;",
            },
            {
                key: "",
                val:
                    "2. Face registration, face recognition, face pass, face attendance, and witness verification (optional)",
            },
            {
                key: "Registration information collection method",
                val:
                    "1. The collector is used to collect information, and the information binding is realized by intelligent identification system;",
            },
            {
                key: "",
                val:
                    "2. Non contact, automatic trigger local acquisition, automatic synchronization",
            },
            { key: "", val: "3. Support information update." },
            { key: "Recognition distance", val: "45~80cm" },
            {
                key: "Identify height range",
                val:
                    "It supports automatic adjustment according to user's height, with coverage up to 50cm",
            },
            { key: "Average registration time", val: "＜3s" },
            { key: "Average recognition time", val: "＜1s" },
            { key: "User capacity", val: "50000人" },
            { key: "accuracy ", val: "FAR<0.0001%,FRR<0.1%" },
            {
                key: "Identification / customs clearance mode",
                val: "1、Any monocular or binocular iris；",
            },
            { key: "", val: "2. Human face;" },
            { key: "", val: "3. Iris face fusion;" },
            { key: "", val: "4. Password input;" },
            {
                key: "",
                val: "5、It supports NFC, and can be configured with 1,2,3,4 any mode and or",
            },
        ],
    },
    {
        imgPo: "imgLeft",
        toHomeImg: "/static/img/product/s330t.png",
        type: "S330-T",
        name: "Temperature measurement iris face recognition machine",
        title: "Temperature measurement iris face recognition machine",
        img: "/static/img/product/s330t.png",  
        point: ["No contact detection, safety and hygiene", "Identification effect, accurate and efficient", "Plug and play, rapid deployment"],
        desc:
            "S330 -t iris temperature entrance guard infrared measuring temperature, iris recognition and face recognition into an organic whole, to wear masks and goggles, rapid temperature screening and highly protective of staff identification precision, can complete early warning of abnormal temperature staff already, also can quickly lock body temperature anomalies recent contacts status, realize high security access control of migrants. Especially suitable for airports, stations and other transportation hubs; Access control in hospitals, schools and government buildings; Factory, enterprise, community entrance, etc.",
        fc: [
            { img: "", name: "No contact detection, safety and hygiene" },
            { img: "", name: "Identification effect, accurate and efficient" },
            { img: "", name: "Plug and play, rapid deployment" },
        ],
        btn: {
            show: true,
            text: "Detail",
        },
        param: [
            { key: "type", val: "S330-T" },
            { key: "product size", val: "160mm*260mm*45mm (width * height * thickness)" },
            { key: "identification distance", val: "identification：45~65cm / to check body temperature：<5cm" },
            { key: "dentify height range", val: "Support automatic adjustment according to the height of the user, covering a range of up to 40cm" },
            { key: "register time", val: "Identification + temperature detection; 2s<3s" },
            { key: "identification time", val: "Identification + temperature detection <2s" },
           
            { key: "accuracy", val: "identity: fifty at a rate of 0.00001%, the reject rate of 0.1% or less/temperature detection: plus or minus 0.3 ℃" },
            { key: "terminal registration database", val: "standard 10,000 user data (can be customized according to user needs) " },
            { key: "near infrared light source", val: "Near infrared light source, LED light source in accordance with IEC-62471 standard" },
            { key: "iris image", val: "conform to ISO29794-6 and ISO19794-6 standards" },
            { key: "face image", val: "in accordance with ISO29794-5 and ISO19794-5 standards" },
            { key: "voice prompt (light)", val: "support " },
        ],
    },
    {
        imgPo: "imgLeft",
        toHomeImg: "/static/img/product/S310.png",
        type: "S310",
        name: "Multi-mode iris face machine",
        title: "Multi-mode iris face machine",
        img: "/static/img/product/S310.png",  
        point: ["低成本", "真性能", "多模态"],
        desc:  "Multi-mode face recognition machine has the characteristics of fast facial feature recognition speed (face < 1s, iris < 1.5s), iris face double in vivo detection to achieve ultra-high security; Support IC card on the basis of iris and face four combination methods, more convenient traffic; Supports conventional networking such as wifi, 4G, and Ethernet for rapid deployment. IPX56 protection level for complex scenarios。",
        fc: [
            { img: "", name: "低成本" },
            { img: "", name: "真性能" },
            { img: "", name: "多模态" },
        ],
        btn: {
            show: true,
            text: "Detail",
        },
        param: [
            {key: "product name ", val:" multi-mode iris all-in-one machine "},
{key: "model ", val: "S310"},
{key: "product size", val: "150 mm * 150 mm33. 5 mm"},
{key: "recognition distance ", val:" Iris: 30~45cm face: 30~100cm NFC card: 0~3cm"},
{key: "identify height range ", val:" Support users to manually adjust the installation Angle of equipment, support 140cm~190cm height coverage; Proactive adaptation;" },
{key: "average registration time ", val: "&lt; 2s" },
{key: "average recognition time ", val: "&lt; 1s" },
{key: "user capacity ", val: "&lt; 10000 "},
{key: "precision ", val: "FAR&lt; 0.0001% FRR&lt; 0.1% "},
            { key: "Registration information collection mode", val: "1. Collect information by collector, bind and deliver information through intelligent identification system; <br>2, non-contact, automatic trigger local collection, automatic synchronization; <br>3, support information update;" },
            { key: "Identification/clearance mode", val: "1, personnel monocular, binocular iris; <br>2, face support white balance; 3. Iris face fusion; <br>4. <br>5, scan input; <br>6, support NFC, can be with 1, 2, 3, 4, 5 any secretary and or configuration;" },
            {key: "interaction mode ", val: "1, screen interaction (face interface research area block diagram, beautiful display interface); 2. Language prompts; 3, support wearing research to avoid light spot hint; "},
            { key: "Live functional", val: "1, support printing/display/face mold and other prosthesis detection; 2, support iris, face alone in vivo detection, in vivo detection accuracy &gt; 90%;" },
            {key: "auxiliary lighting annotation ", 
            val: "1, infrared lighting; Composite IEC62471:2006 non-harm standard, automatic trigger; < BR >2, visible light lighting; Support automatic brightness adjustment, automatic trigger. "},
            {key: "installation and use ", val:" wall-mounted, column type "},
            {key: "working power ", val: "&lt; 16W (theoretical estimate) "},
            {key: "interface ", val:" USB2.0 ; <br>2, 100 MB network port RJ-45; 3. Access control interface: relay; Weigen 26/34 in/out; < BR >4, DC 12V*3A power port (port type: 5.5mm*2.5mm); POE power supply (optional) is supported. <br> <br>" },
            {key: "working environment ", val:" indoor/semi-indoor/outdoor "},
            {key: "working temperature ", val: "-10℃~+50℃)"},
            {key: "work humidity", val:" 20% 90% RH, not dew "},
            {key: "device management ", val:" remote management support "},
        ],
    },
    {
        imgPo: "imgLeft",
        toHomeImg: "/static/img/product/F100.jpg",
        type: "F100",
        name: "Face Recognition All-in-one (Android)",
        title: "Face Recognition All-in-one (Android)",
        img: "/static/img/product/F100.jpg",  
        point: ["安卓系统，7寸人脸机", "自带4G功能"],
        desc:
            "Beautiful product appearance, compact model; Available with metal shell and plastic shell; It can be used in multiple scenarios. Support card swiping and temperature measurement ",
        fc: [
            { img: "", name: "安卓系统，7寸人脸机" },
            { img: "", name: "自带4G功能" },
        ],
        btn: {
            show: true,
            text: "Detail",
        },
        param: [
            {key: "product model ", val: "F100"},
            {key: "screen ", val: "7 inch, IPS, touch screen"},
            {key: "recognition mode ", val:" face + card + temperature measurement "},
            {key: "maximum number of users ", val: "10000"},
            {key: "OS ", val:" android "},
            {key: "waterproof grade ", val: "IP65"},
            {key: "interface", val: "support wiggins door magnetic relay 485 interface, such as"},
        ],
    },
    {
        imgPo: "imgLeft",
        toHomeImg: "/static/img/product/F100.jpg",
        type: "F100(linux)",
        name: "Face Recognition All-in-one (Linux)",
        title: "Face Recognition All-in-one (Linux)",
        img: "/static/img/product/F100.jpg",  
        point: ["产品外观精美，机型紧凑", "有金属外壳及塑胶外壳可选"],
        desc:
            " Linux system, 7-inch face machine standard features: 7-inch IPS screen, binocular wide dynamic, 10,000 face library optional functions: WiFi, swipe card, temperature measurement; 4 g; Floor stand ",
        fc: [
            { img: "", name: "Linux系统" },
            { img: "", name: "7寸人脸机" },
        ],
        btn: {
            show: true,
            text: "Detail",
        },
        param: [
            {key: "product model ", val: "F100"},
            {key: "screen ", val: "7 inch, IPS, touch screen"},
            {key: "recognition mode ", val:" face + card + temperature measurement "},
            {key: "maximum number of users ", val: "10000"},
            {key: "OS ", val: "Linux"},
            {key: "waterproof grade ", val: "IP65"},
            {key: "interface", val: "support wiggins door magnetic relay 485 interface, such as"},
        ],
    },
    {
        imgPo: "imgLeft",
        toHomeImg: "/static/img/product/F300.png",
        type: "F300",
        name: "Face health code recognition machine",
        title: "Face health code recognition machine",
        img: "/static/img/product/F300.png",  
        point: ["产品外观精美，机型紧凑", "有金属外壳及塑胶外壳可选"],
        desc:
            "F300 face health code recognition machine has a mature APP and cloud platform, which can connect with the health code of many provinces and regions; Hardware direct connection support Android platform, convenient and quick connection to local interfaces; 8 inch touch screen for easy operation ",
        fc: [
            { img: "", name: "安卓系统" },
            { img: "", name: "电子哨兵" },
            { img: "", name: "人脸识别+健康码（二维码）" },
        ],
        btn: {
            show: true,
            text: "Detail",
        },
        param: [
            {key: "product model ", val: "F300"},
{key: "screen ", val: "8 inch, IPS, touch screen"},
{key: "recognize patterns", val: "facial recognition + temperature + qr code + id"},
{key: "maximum number of users ", val: "10000"},
{key: "OS ", val:" android "},
        ],
    },
   
    {
        imgPo: "imgLeft",
        toHomeImg: "/static/img/product/s.png",
        type: "Site face recognition machine",
        name: "",
        title: "Site face recognition machine",
        img: "/static/img/product/s.png",  
        point: [],
        desc:"The site 'barrel machine' has been connected to the work network and a number of local platforms. 7 inch, TN screen, Linux system, monocular, 10,000 face library",
        fc: [
            // { img: "", name: "安卓系统" },
            // { img: "", name: "电子哨兵" },
            // { img: "", name: "人脸识别+健康码（二维码）" },
        ],
        btn: {
            show: true,
            text: "Detail",
        },
        param: [
            {key: "product model ", val:" site face recognition machine "},
            {key: "screen ", val: "7 inch, TN screen"},
            {key: "recognize pattern ", val:" support vi/O "},
            {key: "maximum number of users ", val: "10000"},
            {key: "OS ", val: "Linux"},
        ],
    },
    {
        imgPo: "imgLeft",
        toHomeImg: "/static/img/product/aibox.png",
        type: "AI视觉分析边缘计算盒子",
        name: "",
        label:1,
        title: "",
        img: "/static/img/product/aibox.png",  
        point: ['算力强大','算法全面','部署灵活','兼容性强'],
        desc:" AI edge visual analysis calculation of box carrying zhongke rainbow star algorithm independent research and development, realize the dress code detection, an illegal action detection, fire control safety inspection, and other customized analysis, implementation scenario personnel for the monitoring, objects, environment core essential factor of abnormal analysis, at the same time, cooperate with the domestic terminal, computer, mobile terminal APP for early warning and push, Greatly improve the safety and convenience of customer operation management. The product is suitable for government affairs (public security, border inspection, emergency), enterprises (pharmaceutical factory, pharmaceutical enterprises, semiconductor, optics, automobile) and other industries. ",
        fc: [
            { img: "", name: "算力强大" },
            { img: "", name: "算法全面" },
            { img: "", name: "部署灵活" },
            { img: "", name: "兼容性强" },
        ],
        btn: {
            show: true,
            text: "Detail",
        },
        param: [
            {key: "support INT8 peak power up to 17.6T ", val:" "},
            {key: "support 2.2 T FP32 precision work force", val: ""},
            {key: "the dress code detection: protective clothing, hair mask, goggles, masks, etc", val: ""},
            {key: "violation detection: leaving post, talking on the phone, sleeping, smoking, trespassing, stealing, etc. ", val:" "},
            {key: "fire safety inspection: fire, smoke and presence", val: ""},
            {key: "custom test: fume hood,' five pairs ', equipment state, etc., support custom model training ", val: ""},
            {key: "support - 20 ℃ to + 60 ℃ warm working environment", val: ""},
            {key: "support IP40 protection level ", val:" "},
            {key: "mainstream hd video monitoring: hai kang, dahua, such as huawei", val: ""},
            {key: "algorithm framework: Caffe/Tensorflow/PyTorch/Mxnet/Darknet/ Paddle ", val:" "},
        ],
    },
    {
        imgPo: "imgLeft",
        toHomeImg: "/static/img/product/aianalyse.png",
        type: "AI视觉分析服务器",
        name: "",
        title: "",
        label:1,
        img: "/static/img/product/aianalyse.png",  
        point: ['算力强大','算法库全面','兼容性强'],
        desc:"AI visual analysis server carry zhongke rainbow star algorithm independent research and development, realize the dress code detection, an illegal action, fire control safety inspection, and other customized analysis, implementation scenario personnel for the monitoring, objects, environment core essential factor of abnormal analysis, at the same time, cooperate with the domestic terminal, computer, mobile terminal APP for early warning and push, Greatly improve the safety and convenience of customer operation management. The product is suitable for government (public security, border inspection, emergency, aerospace), enterprises (pharmaceutical factory, pharmaceutical enterprises, semiconductor, electronics, automobile) and other industries.",
        fc: [
            { img: "", name: "算力强大" },
            { img: "", name: "算法库全面" },
            { img: "", name: "部署灵活" },
        ],
        btn: {
            show: true,
            text: "Detail",
        },
        param: [
            { key: "Supports INT8 peak power of 528T", val: "  " },
            { key: "the biggest support 66 t FP32 precision work force", val: "  " },
            { key: "the dress code detection: protective clothing, hair mask, goggles, masks, etc", val: "  " },
            { key: "iolation detection: leaving post, talking on the phone, sleeping, smoking, trespassing, stealing, etc.", val: "  " },
            { key: "fire safety inspection: fire, smoke and presence", val: "  " },
            { key: "custom test: fume hood,' five pairs ', equipment state, etc.support custom model training ", val: "  " },
            { key: "mainstream HD video surveillance: Haikang, Dahua, Huawei, etc", val: "  " },
            { key: "algorithm framework: Caffe/Tensorflow/PyTorch/Mxnet/Darknet/ Paddle", val: "  " },
            { key: "OS: CentOS/Ubuntu/Debian", val: "  " },
            { key: "domestic CPU: the fit, sea ray, ShenWei, dragon chip", val: "  " },
            { key: "domestic operating system: kirin, UOS system letter", val: "  " },
        ],
    },
];

// 给每一项添加唯一id
const addId = () => {
    for (let i = 0; i < productList.length; i++) {
        productList[i].id = i + 1;
    }
};
addId();

export default productList;
